import { render, staticRenderFns } from "./MasterFile.vue?vue&type=template&id=010775d4&"
import script from "./MasterFile.vue?vue&type=script&lang=js&"
export * from "./MasterFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports